export default {
	api: 'http://localhost:6500',
	google_api_key: 'AIzaSyCMemvPW5Ehd7i_ILHg_yv7UoTRLdNdZLQ',
	loginTimeout: 18000000
};
